/* Personalizzazione Piquadro · modulo home (solo visivo)
   ------------------------------------------------------------------------
   Le iniziali scritte compaiono sul prodotto finito (monogram tag, stampa
   sullo zaino) e passano alla landing con ?testo=.
   Rispetto al prototipo: init per istanza ([data-pzh]) con reinizializzazione
   nell'editor, link costruiti a partire dall'href gia' localizzato in Liquid
   (prefisso del mercato incluso), niente PZ_CONFIG globale. */
(() => {
  if (window.__pqPzHome) return;
  window.__pqPzHome = true;

  const $$ = (s, r) => [...r.querySelectorAll(s)];
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Prospettiva del tag: stessa matrice della landing */
  const adj = m => [m[4]*m[8]-m[5]*m[7], m[2]*m[7]-m[1]*m[8], m[1]*m[5]-m[2]*m[4], m[5]*m[6]-m[3]*m[8], m[0]*m[8]-m[2]*m[6], m[2]*m[3]-m[0]*m[5], m[3]*m[7]-m[4]*m[6], m[1]*m[6]-m[0]*m[7], m[0]*m[4]-m[1]*m[3]];
  const mm = (a, b) => { const c = []; for (let i = 0; i < 3; i++) for (let j = 0; j < 3; j++) { let s = 0; for (let k = 0; k < 3; k++) s += a[3*i+k] * b[3*k+j]; c[3*i+j] = s; } return c; };
  const mv = (m, v) => [m[0]*v[0]+m[1]*v[1]+m[2]*v[2], m[3]*v[0]+m[4]*v[1]+m[5]*v[2], m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];
  const basis = p => { const m = [p[0], p[2], p[4], p[1], p[3], p[5], 1, 1, 1]; const v = mv(adj(m), [p[6], p[7], 1]); return mm(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]); };
  const project = (w, h, d) => { const t = mm(basis(d), adj(basis([0, 0, w, 0, w, h, 0, h]))); const f = t.map(x => x / t[8]); return `matrix3d(${f[0]},${f[3]},0,${f[6]},${f[1]},${f[4]},0,${f[7]},0,0,1,0,${f[2]},${f[5]},0,1)`; };

  function init(root) {
    if (root.__pzh) return;
    const ac = new AbortController();
    root.__pzh = ac;
    const on = (t, ev, fn, o = {}) => t && t.addEventListener(ev, fn, Object.assign({}, o, { signal: ac.signal }));

    const input = root.querySelector('[data-pzh-input]');
    const outs = $$('[data-pzh-out]', root);
    const tiles = $$('.pzh-tile', root);
    const links = $$('[data-pzh-link]', root).map(a => ({ a, base: a.getAttribute('href') }));

    /* Tile "Sul prodotto": a ogni caricamento uno degli zaini dei blocchi, a caso */
    const printTile = root.querySelector('[data-bags]');
    if (printTile) {
      let bags = [];
      try { bags = JSON.parse(printTile.dataset.bags); } catch (e) { bags = []; }
      if (bags.length > 1) {
        const B = bags[Math.floor(Math.random() * bags.length)];
        const box = printTile.querySelector('.pzh-tile__photo'), img = box.querySelector('img'), quad = box.querySelector('[data-quad]');
        Object.assign(box.dataset, { scale: B.scale, y: B.y });
        img.setAttribute('width', B.w); img.setAttribute('height', B.h); img.src = B.src; img.alt = B.alt || '';
        quad.dataset.quad = B.quad;
        const bx = String(B.box || '400,380').split(',');
        Object.assign(quad.style, { width: bx[0] + 'px', height: bx[1] + 'px' });
      } else if (bags.length === 1) {
        const bx = String(bags[0].box || '400,380').split(',');
        const quad = printTile.querySelector('[data-quad]');
        Object.assign(quad.style, { width: bx[0] + 'px', height: bx[1] + 'px' });
      }
    }

    const fit = () => tiles.forEach(tile => {
      const box = tile.querySelector('.pzh-tile__photo'), img = box && box.querySelector('img'), frame = box && box.querySelector('.pzh-tile__frame');
      if (!img || !frame) return;
      const cw = box.clientWidth, ch = box.clientHeight, iw = img.naturalWidth || +img.getAttribute('width'), ih = img.naturalHeight || +img.getAttribute('height');
      if (!cw || !ch || !iw || !ih) return;
      // "contain": il prodotto si vede intero (scalato e posizionato in verticale), altrimenti copertura piena
      const contain = box.dataset.fit === 'contain';
      const s = contain ? Math.min(cw / iw, ch / ih) * (+box.dataset.scale || 1) : Math.max(cw / iw, ch / ih);
      const w = iw * s, h = ih * s;
      const geo = { width: w + 'px', height: h + 'px', left: (cw - w) / 2 + 'px', top: (ch - h) * (+(box.dataset.y || .5)) + 'px' };
      Object.assign(frame.style, geo);
      Object.assign(img.style, geo, { position: 'absolute', objectFit: 'fill', maxWidth: 'none' });
      const quad = frame.querySelector('[data-quad]');
      if (quad && quad.dataset.quad && quad.dataset.quad.trim()) {
        // angoli relativi alla foto (0-1); valori > 1 = pixel della foto originale
        const q0 = quad.dataset.quad.trim().split(/\s+/).map(p => p.split(',').map(Number));
        if (q0.length !== 4 || q0.flat().some(Number.isNaN)) return;
        const q = q0.flat().every(v => v <= 1.5) ? q0.map(([x, y]) => [x * w, y * h]) : q0.map(([x, y]) => [x * w / iw, y * w / iw]);
        const lerp = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
        const f = 'full' in quad.dataset ? 1 : .8;
        quad.style.transform = project(quad.offsetWidth, quad.offsetHeight, [q[0], q[1], lerp(q[1], q[2], f), lerp(q[0], q[3], f)].flat());
      }
    });

    const sync = popIt => {
      if (!input) return;
      const v = input.value.replace(/[^A-Za-zÀ-ÿ&.]/g, '');
      if (v !== input.value) input.value = v;
      const txt = v.trim() || input.placeholder;
      outs.forEach(o => { o.textContent = txt; });
      // l'href di partenza arriva da Liquid con il prefisso del mercato: si aggiunge solo ?testo=
      links.forEach(({ a, base }) => {
        const url = new URL(base, location.href);
        url.searchParams.set('testo', txt);
        a.href = url.pathname + url.search;
      });
      if (popIt && !reduce()) tiles.forEach(t => { t.classList.remove('is-pop'); void t.offsetWidth; t.classList.add('is-pop'); });
    };
    on(input, 'input', () => sync(true));
    on(window, 'resize', fit);
    $$('img[data-photo]', root).forEach(i => on(i, 'load', fit));
    sync(false);
    fit();
  }

  const boot = scope => $$('[data-pzh]', scope || document).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:unload', e => $$('[data-pzh]', e.target).forEach(r => { if (r.__pzh) { r.__pzh.abort(); r.__pzh = null; } }));
})();
